<template>
  <v-dialog v-model="dialogProxy" max-width="800" persistent>
    <v-card class="dialog-card" elevation="0">
      <v-card-title
        class="dialog-title d-flex justify-space-between align-center"
      >
        <div class="d-flex align-center">
          <v-icon class="mr-2" color="#F4811F">
            mdi-file-document-edit-outline
          </v-icon>
          <span class="dialog-title-text">{{ title }}</span>
        </div>

        <v-btn icon small @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider />

      <v-card-text class="dialog-body">
        <v-container class="pa-0">
          <v-row>
            <v-col cols="12">
              <div class="label-text mb-1">หัวข้อข่าว <span class="red--text">*</span></div>
              <v-text-field
                v-model="localItem.title"
                placeholder="ระบุหัวข้อข่าว"
                outlined
                dense
                hide-details
                class="rounded-lg"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <div class="label-text mb-1">สถานะ</div>
              <v-select
                v-model="localItem.status"
                :items="['เผยแพร่', 'ซ่อน']"
                outlined
                dense
                hide-details
                class="rounded-lg"
              ></v-select>
            </v-col>

            <v-col cols="12" md="6">
              <div class="label-text mb-1">Tags (คั่นด้วย ,)</div>
              <v-text-field
                v-model="localItem.tags"
                placeholder="เช่น news, event"
                outlined
                dense
                hide-details
                class="rounded-lg"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <div class="label-text mb-1">ผู้เขียน</div>
              <v-text-field
                v-model="localItem.author"
                placeholder="ระบุชื่อผู้เขียน"
                outlined
                dense
                hide-details
                class="rounded-lg"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <div class="label-text mb-1">รูปภาพปก</div>
              <div class="d-flex align-center">
                 <v-btn
                  color="#FEF3ED"
                  class="upload-btn mr-4"
                  elevation="0"
                  @click="$refs.fileInput.click()"
                >
                  <span style="color: #F4811F; font-weight: 600;">
                    <v-icon left color="#F4811F">mdi-cloud-upload</v-icon>
                    อัปโหลดรูปภาพ
                  </span>
                </v-btn>
                <input
                    ref="fileInput"
                    type="file"
                    accept="image/*"
                    style="display: none"
                    @change="onFilePreview"
                />
                
                <div v-if="previewUrl" class="image-preview-wrapper ml-4">
                    <v-img 
                        :src="previewUrl" 
                        max-width="120" 
                        max-height="80" 
                        contain 
                        class="rounded-lg"
                    ></v-img>
                    <v-btn icon x-small class="delete-img-btn" @click="removeImage">
                        <v-icon color="red">mdi-close-circle</v-icon>
                    </v-btn>
                </div>
              </div>
            </v-col>

            <v-col cols="12">
              <div class="label-text mb-1">เนื้อหาข่าว <span class="red--text">*</span></div>
              <mavon-editor 
                 v-model="localItem.detail" 
                 language="en"
                 :toolbars="toolbars"
                 style="height: 400px; z-index: 1"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn
          color="#F3F4F6"
          class="cancel-btn mr-2"
          elevation="0"
          @click="close"
        >
          <span style="color: #374151">ยกเลิก</span>
        </v-btn>
        <v-btn
          color="#F4811F"
          class="confirm-btn"
          elevation="0"
          @click="save"
        >
          <span style="color: white">บันทึก</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// Import mavon-editor locally if global registration issues occur, 
// but typically used as plugin. We assume global or we add import here.
import { mavonEditor } from "mavon-editor";
import "mavon-editor/dist/css/index.css";

export default {
  name: "BoardFormDialog",
  components: {
    mavonEditor
  },
  props: {
    value: { type: Boolean, default: false },
    item: { type: Object, default: () => ({}) },
    mode: { type: String, default: "create" } // create | edit
  },

  data() {
    return {
      localItem: {
        title: "",
        detail: "",
        status: "เผยแพร่",
        tags: "",
        author: "Admin", // default value
        image: null,
      },
      imageFile: null,
      previewUrl: null,
      
      toolbars: {
        bold: true,
        italic: true,
        header: true,
        underline: true,
        strikethrough: true,
        mark: true,
        superscript: true,
        subscript: true,
        quote: true,
        ol: true,
        ul: true,
        link: true,
        imagelink: true,
        code: true,
        table: true,
        fullscreen: true,
        readmodel: true,
        htmlcode: true,
        help: true,
        undo: true,
        redo: true,
        trash: true,
        save: false,
        navigation: true,
        alignleft: true,
        aligncenter: true,
        alignright: true,
        subfield: true,
        preview: true,
      }
    };
  },

  computed: {
    dialogProxy: {
      get() { return this.value; },
      set(v) { this.$emit("input", v); }
    },
    title() {
      return this.mode === "create" ? "สร้างข่าวใหม่" : "แก้ไขข่าว";
    }
  },

  watch: {
    value(val) {
      if (val) {
        // Reset or fill data when dialog opens
        if (this.mode === 'edit' && this.item) {
            this.localItem = { ...this.item };
            this.previewUrl = this.item.image || null;
        } else {
            this.localItem = {
                title: "",
                detail: "",
                status: "เผยแพร่",
                tags: "",
                author: "Admin",
                image: null,
            };
            this.previewUrl = null;
        }
        this.imageFile = null;
        this.$nextTick(() => {
            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = "";
            }
        });
      }
    }
  },

  methods: {
    close() {
      this.dialogProxy = false;
    },
    
    onFilePreview(e) {
        const file = e.target.files[0];
        if (!file) return;
        
        this.imageFile = file;
        this.previewUrl = URL.createObjectURL(file);
    },
    
    removeImage() {
        this.imageFile = null;
        this.previewUrl = null;
        this.localItem.image = null;
        this.$refs.fileInput.value = "";
    },

    save() {
       this.$emit("save", {
           ...this.localItem,
           imageFile: this.imageFile
       });
    }
  }
};
</script>

<style scoped>
.dialog-card {
  border-radius: 16px !important;
  box-shadow: none !important;
}
::v-deep(.v-dialog) {
  box-shadow: none !important;
}
.dialog-title {
  padding: 20px 24px 16px !important;
}
.dialog-body {
  padding: 20px 24px 24px !important;
}
.dialog-title-text {
  font-size: 18px;
  font-weight: 600;
  color: #1f2a39;
}
.label-text {
  font-size: 14px;
  font-weight: 400;
  color: #6b717f;
}
.upload-btn {
    border-radius: 8px !important;
    text-transform: none !important;
    height: 40px !important;
}
.cancel-btn, .confirm-btn {
    border-radius: 8px !important;
    text-transform: none !important;
    height: 40px !important;
    font-weight: 600;
    font-size: 16px;
    width: 100px;
}
.image-preview-wrapper {
    position: relative;
    display: inline-block;
}
.delete-img-btn {
    position: absolute;
    top: -10px;
    right: -10px;
    background: white;
    border-radius: 50%;
}
</style>
